import React, { useState, useMemo } from 'react';
import parameters from '../data/parameters.json';
import './ParameterSearchModal.css';

interface ParameterSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectCommand: (command: string) => void;
}

const ParameterSearchModal: React.FC<ParameterSearchModalProps> = ({ isOpen, onClose, onSelectCommand }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredParameters = useMemo(() => {
    if (!searchTerm) return parameters;
    const term = searchTerm.toLowerCase();
    return parameters.filter(p => 
      p.parameter.toString().includes(term) || 
      p.description.toLowerCase().includes(term)
    );
  }, [searchTerm]);

  if (!isOpen) return null;

  return (
    <div className="param-modal-overlay" onClick={onClose}>
      <div className="param-modal" onClick={(e) => e.stopPropagation()}>
        <div className="param-modal-header">
          <h2>Device Parameters</h2>
          <button className="param-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="param-modal-search">
          <input
            type="text"
            placeholder="Search by parameter number or description..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </div>

        <div className="param-modal-body">
          <table className="param-table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Description</th>
                <th>Default</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredParameters.map((param) => (
                <tr key={param.parameter}>
                  <td>{param.parameter}</td>
                  <td>{param.description}</td>
                  <td>{param.defaultValue}</td>
                  <td>
                    <div className="param-actions">
                      <button
                        className="param-btn param-btn-fetch"
                        onClick={() => {
                          onSelectCommand(`3,1,${param.parameter}`);
                          onClose();
                        }}
                      >
                        📥 Fetch
                      </button>
                      <button
                        className="param-btn param-btn-send"
                        onClick={() => {
                          const value = prompt(`Enter value for parameter ${param.parameter}:`, param.defaultValue);
                          if (value !== null) {
                            onSelectCommand(`4,1,${param.parameter},${value}`);
                            onClose();
                          }
                        }}
                      >
                        📤 Send
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ParameterSearchModal;
